<template>
  <el-container class="mg-report-container">
    <el-aside :width="width" class="report-menus">
      <span class="collapse-icon" @click="visible = !visible">{{ collapseIcon }}</span>
      <div class="report-menus-items">
        <div
          v-for="item in buttons"
          :key="item.menuId"
          class="menu-item"
          @click="handleToLink(item)"
          :class="{ active: activeMenuId === item.menuId }"
          :title="item.menuName"
        >
          {{ item.menuName }}
        </div>
      </div>
    </el-aside>
    <el-main class="report-content">
      <template v-for="item in iframes">
        <iframe
          v-if="item.extLink"
          class="third-page"
          frameborder="0"
          :key="item.menuId"
          v-show="activeMenuId === item.menuId"
          :src="item.extLink"
        />

        <component v-else :key="item.menuId" v-show="activeMenuId === item.menuId" :is="item.path"></component>
      </template>
    </el-main>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import md5 from 'crypto-js/md5'
  import qs from 'qs'
  import { salt, channel } from '@/config'
  import AES from '@/utils/cryptojsAES'
  import TransactionReport from './components/TransactionReport.vue'
  import ProductLedger from './components/ProductLedger.vue'
  export default {
    components: { TransactionReport, ProductLedger },
    data() {
      return {
        visible: true,
        activeMenuId: 0,
        iframes: [],
      }
    },
    computed: {
      ...mapGetters({
        belongId: 'user/belongId',
        belongCode: 'user/belongCode',
        employeeName: 'user/employeeName',
        employeeNo: 'user/employeeNo',
      }),
      buttons() {
        let buttons = []
        if (this.$route.meta.buttons.length > 0) {
          console.log('TIPS buttons:', this.$route.meta.buttons)
          //把导出按钮去掉 2025/12/23修改 按钮的下面加按钮权限 读不到下级按钮权限，所以如此修改
          // plSearch //plExport
          // buttons = this.$route.meta.buttons.filter((item) => item.path !== 'plExport')
          this.$route.meta.buttons.forEach((item) => {
            if (item.path !== 'plExport' && item.path !== 'plSearch') {
              buttons.push(item)
            }
          })
        }
        return buttons
      },
      width() {
        return this.visible ? this.$pxToRem(244) : this.$pxToRem(80)
      },
      collapseIcon() {
        return this.visible ? '«' : '»'
      },
      isActiveIframe() {
        return this.iframes.findIndex((item) => item.menuId === this.activeMenuId) !== -1
      },
    },
    mounted() {
      this.setActiveMenuItem()
    },
    methods: {
      setActiveMenuItem() {
        const button = this.buttons.find((item) => item.menuId == this.$route.query.menuId)
        if (button) {
          this.handleToLink(button)
        }
      },
      handleToLink(item) {
        console.log('TIPS handleToLink:', item)
        this.activeMenuId = item.menuId
        // 需要AES加密的链接处理
        const needAESUrls = ['dh.datart.mg.cn']
        // 十六位十六进制数作为密钥
        const key = 'RktYdXd47yPjvq2c'
        const AESEncryptText = AES.encrypt(key, {
          param_partner_code: this.belongCode,
          param_employee_no: this.employeeNo,
        })
        this.$nextTick(() => {
          if (!this.isActiveIframe) {
            if (item.extLink && item.extLink.startsWith('http')) {
              const url = new URL(item.extLink)
              const params = qs.parse(url.search, { ignoreQueryPrefix: true })
              if (needAESUrls.includes(url.host)) {
                // 链接有效性: 1个小时
                const AESXtimestamp = new Date().getTime() + 60 * 60 * 1000
                // 验签 -- sourceCode + timestamp + secre 进行md5加密
                const signature = md5('2' + AESXtimestamp + 'b9bf7aa941d043017ec667287d6c2d64').toString()
                params['user'] = this.employeeName
                params['parameter'] = AESEncryptText
                params['timestamp'] = AESXtimestamp
                params['signature'] = signature
                const urlParams = Object.keys(params).map((item) => {
                  let itemStr = `${item}=${params[item]}`
                  return itemStr
                })
                item.extLink = `${url.origin}${url.pathname}?&${urlParams.join('&')}`
                this.iframes.push(item)
                return false
              }
              params.param_partner_id = this.belongId
              params.param_partner_code = this.belongCode
              url.search = qs.stringify(params, { addQueryPrefix: true })
              const xtimestamp = new Date().getTime()
              const xsign = md5(md5(url.pathname + url.search + salt).toString() + xtimestamp).toString()
              params['X-SIGN'] = xsign
              params['X-EXT-CHANNEL'] = channel
              params['X-TIMESTAMP'] = xtimestamp
              url.search = qs.stringify(params, { addQueryPrefix: true })
              item.extLink = url.toString()
              this.iframes.push(item)
            } else {
              this.iframes.push(item)
            }
          }
        })
      },
      handleCollapse() {
        this.visible = !this.visible
      },
    },
  }
</script>
<style lang="scss">
  .mg-report-container {
    min-height: calc(100vh - 48px) !important;
    background: #ebedf0 !important;
    padding: 8px !important;
    .report-menus {
      background: #fff;
      margin-right: 8px;
      position: relative;
      overflow-x: hidden;
      .collapse-icon {
        width: 32px;
        height: 20px;
        position: absolute;
        right: 0px;
        top: 0px;
        color: #fff;
        font-size: 32px;
        line-height: 12px;
        border-radius: 20px 0 0 20px;
        padding-left: 10px;
        padding-top: 4px;
        box-sizing: border-box;
        background: $mg--color-primary;
        cursor: pointer;
      }
      .report-menus-items {
        overflow: auto;
        .menu-item {
          color: #292e40;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding: 10px 16px;
          font-size: 20px;
          font-weight: 600;
          &:hover {
            background: $mg-row-hover-color;
            cursor: pointer;
          }
          &.active {
            background: $mg-row-active-color;
          }
        }
      }
    }

    .report-content {
      background: #fff;
      padding: 8px;
      .third-page {
        width: 100%;
        height: calc(100vh - 83px);
      }
    }
  }
</style>
